export const translations = {
  it: {
    // Header navigation
    nav: {
      home: 'Home',
      about: 'Chi sono',
      experience: 'Esperienza',
      education: 'Formazione',
      contact: 'Contatti'
    },
    
    // Hero section
    hero: {
      greeting: 'Ciao, sono',
      title: 'Senior Front-end Engineer',
      subtitle: 'Architettura Front-end enterprise, Design System engineering e integrazione AI',
      cta: 'Scopri di più',
      downloadCV: 'Scarica CV'
    },
    
    // About section
    about: {
      title: 'Chi sono',
      description: "Mi ritengo una persona responsabile, capace di impegnarsi con entusiasmo e motivazione su tutto ciò che mi si presenti come un'occasione per migliorare me stesso e ampliare le mie conoscenze. So lavorare ad un progetto identificandomi totalmente in un team e mi trovo a mio agio nello svolgimento di compiti individuali.",
      personal: {
        title: 'Informazioni personali',
        citizenship: 'Cittadinanza',
        birthDate: 'Data di nascita',
        city: 'Città',
        phone: 'Telefono',
        email: 'Email'
      }
    },
    
    // Experience section
    experience: {
      title: 'Esperienza & Competenze',
      current: 'attuale',
      role: 'Ruolo',
      company: 'Azienda',
      period: 'Periodo'
    },
    
    // Education section
    education: {
      title: 'Formazione',
      degree: 'Titolo',
      institution: 'Istituto',
      grade: 'Voto',
      subjects: 'Materie principali',
      languages: 'Lingue'
    },
    
    // Footer
    footer: {
      rights: 'Tutti i diritti riservati',
      madeWith: 'Realizzato con',
      by: 'da'
    },

    // Common
    common: {
      readMore: 'Leggi di più',
      readLess: 'Mostra meno',
      viewProject: 'Vedi progetto',
      viewAll: 'Vedi tutto',
      backToTop: 'Torna su'
    }
  },
  
  en: {
    // Header navigation
    nav: {
      home: 'Home',
      about: 'About',
      experience: 'Experience',
      education: 'Education',
      contact: 'Contact'
    },
    
    // Hero section
    hero: {
      greeting: 'Hi, I\'m',
      title: 'Senior Front-end Engineer',
      subtitle: 'Enterprise Front-end architecture, Design System engineering and AI integration',
      cta: 'Learn more',
      downloadCV: 'Download CV'
    },
    
    // About section
    about: {
      title: 'About me',
      description: "I consider myself a responsible person, capable of engaging with enthusiasm and motivation in everything that presents itself as an opportunity to improve myself and expand my knowledge. I can work on a project by fully identifying with a team and I feel comfortable performing individual tasks.",
      personal: {
        title: 'Personal information',
        citizenship: 'Citizenship',
        birthDate: 'Birth date',
        city: 'City',
        phone: 'Phone',
        email: 'Email'
      }
    },
    
    // Experience section
    experience: {
      title: 'Experience & Skills',
      current: 'current',
      role: 'Role',
      company: 'Company',
      period: 'Period'
    },
    
    // Education section
    education: {
      title: 'Education',
      degree: 'Degree',
      institution: 'Institution',
      grade: 'Grade',
      subjects: 'Main subjects',
      languages: 'Languages'
    },
    
    // Footer
    footer: {
      rights: 'All rights reserved',
      madeWith: 'Made with',
      by: 'by'
    },

    // Common
    common: {
      readMore: 'Read more',
      readLess: 'Show less',
      viewProject: 'View project',
      viewAll: 'View all',
      backToTop: 'Back to top'
    }
  }
};

// Hook helper per usare le traduzioni
export const useTranslations = (language) => {
  return translations[language] || translations.it;
};
